import { cn } from "../utils/helpers";
import { SvgProps } from "../utils/types";

export default function CheckIcon({ className }: SvgProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={cn("size-3.5 shrink-0", className)}
        >
            <polyline points="20 6 9 17 4 12" />
        </svg>
    );
}
